import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Collapse } from 'react-collapse'
import { Button } from './'
const FooterOuter = styled.footer`
  background-color: #333333;
  padding: 40px 20px;
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const Img = styled.img`
  height: 20px;
  width: 65px;
  object-fit: contain;
`
// const HorizontalLine = styled.div`
//   border-radius: 1px;
//   height: 1px;
//   background-color: rgba(255, 255, 255, 0.2);
//   margin-top: 10px;
// `
const CollapseWrapper = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1px;
  padding-bottom: 8px;
  padding-top: 24px;
  & a {
    text-decoration: none;
    color: #fff;
    padding-bottom: 8px;
    color: #999999;
    line-height: 1.64;
    letter-spacing: 1.4px;
    transition: 0.2s linear;
    display: block;
  }
`
const CollapseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`
const Arrow = styled.div`
  width: 14px;
  height: 14px;
  border-bottom: 1.5px solid #fff;
  border-right: 1.5px solid #fff;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transform: ${props => (props.rotate ? 'rotate(-135deg)' : 'rotate(45deg)')};
  border-radius: 0.5px;
  margin-right: 6px;
`
const AddressWrapper = styled.div`
  padding-top: 20px;
  & > a {
    padding-top: 8px;
  }
`
const HelpWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  & > a {
    padding-top: 8px;
    display: inline-block;
  }
`
const FooterTitle = styled.h5`
  text-transform: uppercase;
  line-height: 1.64;
  letter-spacing: 1.4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
`
const CollapseContainer = styled.div`
  padding-bottom: 20px;
`
const ContentWrapper = styled.div`
  border-bottom: 1px solid;
  padding: 20px 0;
  border-radius: 1px;
  display: flex;
  justify-content: center;
  ${props =>
    props.column &&
    `
    align-items: center;
    flex-direction: column;
  `};
  & > a {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.67;
    letter-spacing: 1px;
    color: #ffffff;
  }
  & > a:last-child {
    padding-top: 10px;
  }
  & + h2 {
    padding-top: 20px;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.92;
    letter-spacing: 0.1px;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
  }
`
const LinkFooter = styled(Link)`
  text-decoration: none;
  color: #fff;
  padding-bottom: 8px;
  color: #999999;
  line-height: 1.64;
  letter-spacing: 1.4px;
  transition: 0.2s linear;
  display: block;
`
// const SocialCollapse = styled(Collapse)`
//   & > div > a {
//     padding-right: 20px;
//   }
// `
class MobileFooter extends Component {
  state = {
    isCollapseOpen: false,
    clicked: ''
  }
  handleHeader = clicked => {
    this.setState({
      clicked: clicked === this.state.clicked ? '' : clicked
    })
  }
  render() {
    const { clicked } = this.state
    const date_obj = new Date()
    const year = date_obj.getFullYear()
    return (
      <FooterOuter>
        <Link to="/">
          <Img src={require('../static/brand.svg')} alt="8OM" />
        </Link>
        <CollapseContainer>
          <CollapseWrapper>
            <CollapseHeader onClick={() => this.handleHeader('pages')}>
              <FooterTitle>Pages</FooterTitle>
              <Arrow rotate={clicked === 'pages'} />
            </CollapseHeader>
            <Collapse isOpened={clicked === 'pages'}>
              <LinkFooter to="/">HOME</LinkFooter>
              <LinkFooter to="/services">SERVICES</LinkFooter>
              <LinkFooter to="/clients">CLIENTS</LinkFooter>
              <LinkFooter to="/about">ABOUT US</LinkFooter>
              <LinkFooter to="/about#careers">CAREER</LinkFooter>
            </Collapse>
          </CollapseWrapper>
          <CollapseWrapper>
            <CollapseHeader onClick={() => this.handleHeader('services')}>
              <FooterTitle>Services</FooterTitle>
              <Arrow rotate={clicked === 'services'} />
            </CollapseHeader>
            <Collapse isOpened={clicked === 'services'}>
              <LinkFooter to="/services/web-development">WEB DEVELOPMENT</LinkFooter>
              <LinkFooter to="/services/app-development">APP DEVELOPMENT</LinkFooter>
              <LinkFooter to="/services/digital-marketing">DIGITAL MARKETING</LinkFooter>
              <LinkFooter to="/services/experiential-marketing">EXPERIENTIAL MARKETING</LinkFooter>
              <LinkFooter to="/services/web-crawling">WEB CRAWLING</LinkFooter>
              <LinkFooter to="/services/ux-ui">UX/UI</LinkFooter>
            </Collapse>
          </CollapseWrapper>
          <CollapseWrapper>
            <CollapseHeader onClick={() => this.handleHeader('solutions')}>
              <FooterTitle>Products</FooterTitle>
              <Arrow rotate={clicked === 'solutions'} />
            </CollapseHeader>
            <Collapse isOpened={clicked === 'solutions'}>
              <LinkFooter to="/trckr">TRCKR</LinkFooter>
              <LinkFooter to="/extract">EXTRACT</LinkFooter>
              <LinkFooter to="/books">BOOKS</LinkFooter>
            </Collapse>
          </CollapseWrapper>
          <CollapseWrapper>
            <CollapseHeader onClick={() => this.handleHeader('contact')}>
              <FooterTitle>Contact</FooterTitle>
              <Arrow rotate={clicked === 'contact'} />
            </CollapseHeader>
            <Collapse isOpened={clicked === 'contact'}>
              <LinkFooter to="/contact">CONTACT US</LinkFooter>
            </Collapse>
          </CollapseWrapper>
        </CollapseContainer>
        <AddressWrapper>
          <FooterTitle>Address</FooterTitle>
          <a href="https://goo.gl/maps/kijNARhCjCC2" target="_blank" rel="noopener noreferrer">
            3rd Floor, 24 Rajlok Building, Nehru Place, Delhi 110019{' '}
          </a>
        </AddressWrapper>
        <HelpWrapper>
          <FooterTitle>Help</FooterTitle>
          <a href="mailto:harsh@8om.io" target="_top">
            Email - harsh@8om.io
          </a>
          <br />
          <a href="tel:+918076157787">Contact - +91 8076157787</a>
        </HelpWrapper>
        <ContentWrapper>
          <Button width={138} background={'#35cc62'} title="contact us" />
        </ContentWrapper>

        <h2>© {year} 8om All Rights Reserved</h2>
      </FooterOuter>
    )
  }
}

export { MobileFooter }



// WEBPACK FOOTER //
// ./src/components/MobileFooter.js